var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit, faEye, faPen, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { copyWorkflow, updateWorkflow } from "@/components/Workflow/workflows.services";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import TextSummary from "@/components/Common/TextSummary.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import WorkflowActions from "@/components/Workflow/WorkflowActions.vue";
import WorkflowActionsExtend from "@/components/Workflow/WorkflowActionsExtend.vue";
import WorkflowIndicators from "@/components/Workflow/WorkflowIndicators.vue";
import WorkflowInvocationsCount from "@/components/Workflow/WorkflowInvocationsCount.vue";
import WorkflowQuickView from "@/components/Workflow/WorkflowQuickView.vue";
import WorkflowRename from "@/components/Workflow/WorkflowRename.vue";
import WorkflowRunButton from "@/components/Workflow/WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowCard',
    props: {
        workflow: null,
        gridView: { type: Boolean, default: false },
        publishedView: { type: Boolean, default: false }
    },
    emits: ["tagClick", "refreshList", "update-filter"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faEdit, faEye, faPen, faUpload);
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const showRename = ref(false);
        const showPreview = ref(false);
        const workflow = computed(() => props.workflow);
        const shared = computed(() => {
            if (userStore.currentUser) {
                return userStore.currentUser.username !== workflow.value.owner;
            }
            else {
                return false;
            }
        });
        const description = computed(() => {
            if (workflow.value.annotations && workflow.value.annotations.length > 0) {
                return workflow.value.annotations[0].trim();
            }
            else {
                return null;
            }
        });
        const editButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to edit Workflow";
            }
            else {
                if (workflow.value.deleted) {
                    return "You cannot edit a deleted workflow. Restore it first.";
                }
                else {
                    return "Edit Workflow";
                }
            }
        });
        const importedButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to import workflow";
            }
            else {
                return "Import this workflow to edit";
            }
        });
        const runButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to run workflow";
            }
            else {
                if (workflow.value.deleted) {
                    return "You cannot run a deleted workflow. Restore it first.";
                }
                else {
                    return "Run workflow";
                }
            }
        });
        function onImport() {
            return __awaiter(this, void 0, void 0, function* () {
                yield copyWorkflow(workflow.value.id, workflow.value.owner);
                Toast.success("Workflow imported successfully");
            });
        }
        function onRenameClose(e) {
            showRename.value = false;
            emit("refreshList", true);
        }
        function toggleShowPreview(val = false) {
            showPreview.value = val;
        }
        function onTagsUpdate(tags) {
            return __awaiter(this, void 0, void 0, function* () {
                workflow.value.tags = tags;
                yield updateWorkflow(workflow.value.id, { tags });
                emit("refreshList", true, true);
            });
        }
        function onTagClick(tag) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("tagClick", tag);
            });
        }
        return { __sfc: true, props, emit, userStore, isAnonymous, showRename, showPreview, workflow, shared, description, editButtonTitle, importedButtonTitle, runButtonTitle, onImport, onRenameClose, toggleShowPreview, onTagsUpdate, onTagClick, faEdit, faPen, faUpload, FontAwesomeIcon, BButton, AsyncButton, TextSummary, StatelessTags, WorkflowActions, WorkflowActionsExtend, WorkflowIndicators, WorkflowInvocationsCount, WorkflowQuickView, WorkflowRename, WorkflowRunButton };
    }
});
